import { useEffect, useState} from 'react';
import * as React from 'react';
import axios from 'axios';
const SummaryBoxLogic = (props) => {
    const [socialMediaCount,setSocialMediaCount] = useState(0);
    const [weatherCount,setWeatherCount] = useState(0);
    const [newsCount,setNewsCount] = useState(0);
    const [floodMapCount,setfloodMapCount] = useState(0);
    const [evidenceString,setevidenceString] = useState('Our catalog does not contain any data points within 10 miles of your property.');
    const [alignment, setAlignment] = React.useState('Terra Cover Dataset');

    const handleChange = (
      event: React.MouseEvent<HTMLElement>,
      newAlignment: string,
    ) => {
      setAlignment(newAlignment);
    };
    

  
    const [aPCount,setAPCount] = useState(null);
    const [aSum,setASum] = useState(null);
    const [vPCount,setVPCount] = useState(null);
    const [vSum,setVSum] = useState(null);
    const [nonPCount,setOtherPCount] = useState(null);
    const [nonSum,setOtherSum] = useState(null);
    const [expanded, setExpanded] = useState(true);
    const addressArray = props.address.split(',');

    const handleExpandClick = () => {
      setExpanded(!expanded);
    };

    const showFema = () => {
      document.getElementById('fema-table').style.display = 'block';
      document.getElementById('logo-table').style.display = 'none';
      document.getElementById('logo-table2').style.display = 'none';
    }
  
    const showLogos = () => {
      document.getElementById('fema-table').style.display = 'none';
      document.getElementById('logo-table').style.display = 'block';
      document.getElementById('logo-table2').style.display = 'block';
    }

    // code to update tables
    useEffect( () => {
      axios.get(`https://website-267617.uw.r.appspot.com/get_data_points_summary?lat=${props.lat}&long=${props.lng}&dist=0.1`)
        .then(
        (res)=>{
            
          setSocialMediaCount(0);
          setNewsCount(0);
          setWeatherCount(0);
          //setDataPointsCount(0);
          
          var total_data_points = 0;
          for (var i = 0; i < res.data.length; i++) { 
            
            var cur_count = res.data[i]['count']
            var cur_source = res.data[i]['source']
          
            if (cur_source==="news"){setNewsCount(cur_count)}
            if (cur_source==="twitter"){setSocialMediaCount(cur_count)}
            if (cur_source==="weather"){setWeatherCount(cur_count)}
            total_data_points = total_data_points + parseInt(cur_count)
          
          }
         
          if (total_data_points>0){setevidenceString('Our data shows evidence of flooding within 10 miles of your property.')}

        }
      ).catch((err) => console.log(err))

      // flood maps summary
      axios.get(`https://website-267617.uw.r.appspot.com/get_flood_maps_summary?lat=${props.lat}&long=${props.lng}&dist=0.1`)
        .then(
        (res)=>{
          setfloodMapCount(res.data.length)
          if (res.data.length>0){setevidenceString('Our data shows evidence of flooding within 10 miles of your property.')}
            
        }
      ).catch((err) => console.log(err))
      
      // update user log with false flag
      axios.post(`https://website-267617.uw.r.appspot.com/update_coder_log`, {
        "address" : props.address,
        "lat" : 41,
        "lon" : 41,
        "transfer" : 0,
        "distance" : 10
      }).catch((err) => console.log(err))

      
      let lat = props.lat;
      let lng = props.lng;
  
      const roundedLat = Math.round(lat * 10) / 10;
      const roundedLng = Math.round(lng * 10) / 10;
      
      // fema claims summary
      axios.get(`https://website-267617.uw.r.appspot.com/get_exact_a?lat=${roundedLat}&long=${roundedLng}`)
        .then((res) => {
        setAPCount(res.data[0]['apcount'])
        setASum(res.data[0]['aclaims'])
      })
      
      axios.get(`https://website-267617.uw.r.appspot.com/get_exact_v?lat=${roundedLat}&long=${roundedLng}`)
        .then((res) => {
        setVPCount(res.data[0]['vpcount'])
        setVSum(res.data[0]['vclaims'])
      })
      
      axios.get(`https://website-267617.uw.r.appspot.com/get_exact_other?lat=${roundedLat}&long=${roundedLng}`)
        .then((res) => {
        setOtherPCount(res.data[0]['otherpcount'])
        setOtherSum(res.data[0]['otherclaims'])
      })
   },[props.lat,props.lng])

   return({expanded,floodMapCount,evidenceString,socialMediaCount,weatherCount,newsCount,aPCount,aSum,vPCount,
    vSum,nonPCount,nonSum,addressArray,handleExpandClick,showFema,showLogos,alignment,handleChange})
};

export default SummaryBoxLogic;